(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypePatientContactsRelationshipController', TypePatientContactsRelationshipController);

    TypePatientContactsRelationshipController.$inject = ['TypePatientContactsRelationship', 'CoreService',
        'GenericEntityDatatableService', '$q', '$uibModal', 'ConfirmationService'];

    function TypePatientContactsRelationshipController(TypePatientContactsRelationship, CoreService,
                                                       GenericEntityDatatableService, $q, $uibModal, ConfirmationService) {

        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation()

        var entityStateName = 'type-patient-contacts-relationship'

        vm.descriptor = {
            title: 'Patient Contacts Relationships',
            newButtonTitle: 'New Relationships',
            entityClassHumanized: 'Patient Contacts Relationships',
            entityStateName: entityStateName,
            service: TypePatientContactsRelationship,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name'
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Relationships',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/type-patient-contacts-relationship/update/type-patient-contacts-relationship-dialog.html',
                controller: 'TypePatientContactsRelationshipDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/type-patient-contacts-relationship/update/type-patient-contacts-relationship-dialog.html',
                controller: 'TypePatientContactsRelationshipDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['TypePatientContactsRelationship', function (TypePatientContactsRelationship) {
                        return TypePatientContactsRelationship.get({id: id}).$promise;
                    }]
                }
            }).result
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Relationships').result.then(function () {
                    TypePatientContactsRelationship.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();
